import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { VolumeCalculatorComponent } from "../../form-parts/volume-calculator/volume-calculator.component";
import { FormService } from "../../services/form.service";
import { ApiService } from "../../services/api.service";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-moving-boxes',
	templateUrl: './moving-boxes.component.html',
	styleUrls: ['./moving-boxes.component.scss']
})
export class MovingBoxesComponent implements OnInit {

	movingBoxes !: UntypedFormGroup
	formGroupName : string = 'movingBoxes'
	vcPreCategories: any | undefined;

	public baggageSizes = [
		{
			key: 'boxesSmall',
			title: $localize `Small box`,
			size: '30 x 30 x 30 cm',
			descriptionSizeKg: '11 kg',
		},
		{
			key: 'boxesMedium',
			title: $localize `Medium box`,
			size: '46 x 46 x 46 cm',
			descriptionSizeKg: '19 kg',
		},
		{
			key: 'boxesLarge',
			title: $localize `Large box`,
			size: '61 x 46 x 46 cm',
			descriptionSizeKg: '27 kg',
		}
	];

	constructor( public formService: FormService ) {

	}

	public ngOnInit(): void {

		this.movingBoxes = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
	}

	ngAfterViewInit() {

		// After view has loaded
	}

	public onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.movingBoxes) );
	}

	//  === Baggage move action === //
	public itemUp( item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var currentVal = currentControl.value;
		currentControl.setValue(++currentVal );
	}

	public itemDown( item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var currentVal = currentControl.value;

		if( currentVal <= 0 ) {
			return;
		}

		currentControl.setValue(--currentVal );
	}

	public itemInput( event: any,  item: string ) {

		var currentControl = this.movingBoxes.controls[item];
		var value = event.target.value;

		// Don't allow lower than 0
		value = ( value < 0 ? 0 : value );
		currentControl.setValue( value );
	}
}